//本地存储存取方法
import {saveToLocal, loadFromLocal} from "common/js/store"
const state = {
  /***
   * 请求源origin
   * ***测试版通过代理解决跨域问题***
   * ***正式版改为正式请求地址***
   */
  apiRequestURL: "/api",
  
  //全局数据
  username: "zhangsan",
  nickname: "",
  userInfo: {},
  photoUrl: "",
  //重要程度数据
  importanceData: [],
  //浮窗偏移量(层叠布局)
  modalOffsetDistance: {
    x: 0.55,
    y: 0.53
  },
  //日程暂无数据提醒文案库
  noticeEmptyListNotice: [
    'test1',
    'test2',
    'test3',
    'test4',
    'test5',
    'test6',
  ],
  
  //个人资料：基础资料确认情况
  profileBaseConfirmState: 0,
  //个人资料：扩展资料确认情况
  profileExtraConfirmState: 0,
  
  
  //模态框层级
  modalZIndex: 999,
  //系统列表
  systemList: [],
  //通知公告列表
  noticeList: [],
  //皮肤标识
  skinSign: null,
  
  //是否显示loading
  isShowLoading: false,
  
  //右侧栏菜单
  isShowSideMenu: true,
  //是否显示顶部的用户头像
  isShowTopAvatar: true,
  
  //小工具菜单
  toolsList: [
    {
      appid: 1,
      name: "截屏",
      icon: "icon-jieping",
      pc_icon: require("../assets/images/tool_shot.png"),
    },
    {
      appid: 2,
      name: "日程",
      icon: "icon-ht_class",
      pc_icon: require("../assets/images/tool_sch.png"),
    },
    // {
    //   appid: 3,
    //   name: "计算器",
    //   icon: "icon-duorenyonghu-",
    //   pc_icon: require("../assets/images/calc.png"),
    //   pc_url:'https://www.baidu.com/',
    // },
    // {
    //   appid: 4,
    //   name: "通讯录",
    //   icon: "icon-ht_class",
    //   pc_icon: require("../assets/images/txl.png"),
    //   pc_url:'https://www.baidu.com/',
    // },
    {
      appid: 5,
      name: "便签",
      icon: "icon-ht_class",
      pc_icon: require("../assets/images/bianqian.png"),
      pc_url: 'http://jkttb.itdaka.cn:8081/shall/cgi-bin/access/a2d3774f5cf84dd18469ec0501db2c41?url=http://jkttb.itdaka.cn:8083/lightapp/note_login',
    }
  
  
  ],
  
  
  //用户端routerLink
  routers: {
    home: [
      {
        name: "学生办事",
        path: "/home/student",
        isShow: true,
      },
      {
        name: "教师办事",
        path: "/home/teacher",
        isShow: true,
      },
      {
        name: "游客浏览",
        path: "/home/visitor",
        isShow: true,
      },
    ],
    user: [
      {
        name: "首页",
        path: "/home",
        icon: "shouye-shi",
        isShow: true,
      },
      {
        name: "服务中心",
        path: "/service",
        icon: "shiwujiaoxing",
        isShow: true,
      },
      {
        name: "个人中心",
        path: "/personal",
        icon: "geren",
        isShow: true,
      },
      {
        name: "旧版服务平台",
        path: "/jiuban",
        icon: "geren",
        isShow: false,
      },
  
      {
        name: "通知公告",
        path: "/notice",
        icon: "geren",
        isShow: false,
      },
      {
        name: "数据校园",
        path: "/datanalysis",
        icon: "shujufenxitianchong",
        isShow: true,
      },
      {
        name: "数说校园",
        path: "/digit",
        icon: "shujufenxitianchong",
        isShow: true,
      },
      {
        name: "学院网站",
        path: "/website",
        icon: "shujufenxitianchong",
        isShow: true,
      },
      {
        name: "测试",
        path: "/test",
        icon: "gezi",
        isShow: false,
      }
    ],
    manager: []
  },
  
  //会议详情
  meetingColumnDesc: {
    ID: '会议ID',
    HYLX: '会议类型',
    HYDD: '会议地点',
    HYRQ: '会议日期',
    KSSJ: '开始时间',
    JSSJ: '结束时间',
    ZJBM: '召集部门',
    ZCR: '主持人',
    QTZCR: '其他主持人',
    CHRY: '参会人',
    CHLD: '出席会议领导',
    JLY: '会议记录员',
    HYLXR: '会议列席人',
    QTLXR: '其他列席人',
    BZ: '备注',
    YHM: '用户名',
    XM: '姓名'
    
  },
  
  //微应用列表
  microProgramList: [],
  //待办类别
  todoCategory: [],
  //待办部门
  todoDept: []
};

export default state



// WEBPACK FOOTER //
// ./src/store/state.js